webpackJsonp([1],{

/***/ "3Ay6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LTCV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54deb283","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("RjyN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js + 1 modules
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/utils/request.js


var request__this = this;





vue_esm["default"].use(toast["a" /* default */]);
var vm = new vue_esm["default"]();
var service = axios_default.a.create({
  baseURL: '' + "https://api.app.cocinare.com/appApi/v1" + '', // url = base url + request url
  timeout: 5000
});

service.interceptors.request.use(function (config) {

  return config;
}, function (error) {

  console.error(error);
  return promise_default.a.reject(error);
});

service.interceptors.response.use(
/**
* If you want to get http information such as headers or status
* Please return  response => response
*/

/**
* Determine the request status by custom code
* Here is just an example
* You can also judge the status by HTTP Status Code
*/
function (response) {
  var res = response.data;

  if (res && res.code !== 200) {
    vm.$vux.toast.show({
      type: 'text',
      position: 'middle',
      text: res.msg
    });
    return promise_default.a.reject(new Error(res.msg || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  console.error('http error：' + error);
  request__this.$vux.toast.show({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return promise_default.a.reject(error);
});

/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/api/public.js


// 设备新手指引
function public_getGuide(identity, language) {
  return request({
    url: '/device/guide',
    method: 'POST',
    params: { identity: identity, language: language }
  });
}

// 分享
function getShare(identity) {
  return request({
    url: '/user/device/brew/share/info',
    method: 'POST',
    params: { identity: identity }
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/guide/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var guide = ({
  name: 'guide',
  data: function data() {
    return {
      identity: null,
      language: null,
      doc: ''
    };
  },
  mounted: function mounted() {
    this.identity = this.$route.params.identity;
    this.language = this.$route.params.language;
    this.getGuide();
  },

  methods: {
    // 获取新手指引内容
    getGuide: function getGuide() {
      var _this = this;

      public_getGuide(this.identity, this.language).then(function (res) {
        _this.doc = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/guide/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_guide = ({
  name: 'guide',
  data: function data() {
    return {
      identity: null,
      language: null,
      doc: ''
    };
  },
  mounted: function mounted() {
    this.identity = this.$route.params.identity;
    this.language = this.$route.params.language;
    this.getGuide();
  },

  methods: {
    // 获取新手指引内容
    getGuide: function getGuide() {
      var _this = this;

      public_getGuide(this.identity, this.language).then(function (res) {
        _this.doc = res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dea0021","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide/index.vue
var guide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containers"},[(_vm.doc !== '')?_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.doc)}}):_c('div',{staticStyle:{"text-align":"center","padding":"20px"}},[_vm._v("\n    暂无新手指引，敬请期待。\n  ")])])}
var guide_staticRenderFns = []
var guide_esExports = { render: guide_render, staticRenderFns: guide_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_guide = (guide_esExports);
// CONCATENATED MODULE: ./src/components/guide/index.vue
function guide_injectStyle (ssrContext) {
  __webpack_require__("3Ay6")
}
var guide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var guide___vue_template_functional__ = false
/* styles */
var guide___vue_styles__ = guide_injectStyle
/* scopeId */
var guide___vue_scopeId__ = "data-v-2dea0021"
/* moduleIdentifier (server only) */
var guide___vue_module_identifier__ = null
var guide_Component = guide_normalizeComponent(
  components_guide,
  selectortype_template_index_0_src_components_guide,
  guide___vue_template_functional__,
  guide___vue_styles__,
  guide___vue_scopeId__,
  guide___vue_module_identifier__
)

/* harmony default export */ var src_components_guide = (guide_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/echarts/index.js + 577 modules
var echarts = __webpack_require__("XLwt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/share/index.vue





//




function fetchShareMock() {
  return new promise_default.a(function (resolve) {
    setTimeout(function () {
      resolve({
        brewInfo: {
          title: '圣诞梦之夜',
          barista: '蜡笔小新',
          brewTime: '01-03 22:00',
          brewDate: '2024年01月03日 22:00',
          duration: '00:00:30'
        },
        brewParams: {
          bean: '15.0',
          water: '230',
          scale: '1:15.13',
          finalScale: '1:14.8',
          flask: '240',
          ratio: '1:15.7'
        },
        equipments: [{ name: '手冲壶', emoji: '🫖', image: '' }, { name: '研磨器', emoji: '', image: 'https://via.placeholder.com/100x100/FF9B44/FFFFFF?text=研磨' }, { name: '滤杯', emoji: '🥤', image: '' }, { name: '电子秤', emoji: '', image: 'https://via.placeholder.com/100x100/36D3E8/FFFFFF?text=秤' }, { name: '温度计', emoji: '🌡️', image: '' }, { name: '计时器', emoji: '⏱️', image: '' }],
        tastings: [{ name: '分享壶', emoji: '🫗', image: '' }, { name: '品鉴杯', emoji: '☕', image: '' }, { name: '滤纸', emoji: '🧻', image: '' }, { name: '闻香杯', emoji: '🥃', image: '' }, { name: '杯测勺', emoji: '🥄', image: '' }, { name: '风味轮', emoji: '🎨', image: '' }],
        coffeeBean: {
          name: '埃塞俄比亚 耶加雪菲',
          origin: '埃塞俄比亚',
          estate: '耶加雪菲',
          roastLevel: '浅度烘焙'
        },
        chartData: {
          weightArray: [100, 280, 360, 400, 430, 470, 500],
          flowRateArray: [0, 7.5, 5.2, 3.8, 2.5, 1.8, 1.2],
          avgFlowRateArray: [0, 7.5, 6.35, 5.5, 4.8, 5.6, 3.67]
        }
      });
    }, 500);
  });
}

function convertTo2DArray(array) {
  return array.map(function (value, index) {
    return [index * 20, value];
  });
}

function convertApiData(apiData) {
  var imgHost = "https://api.app.cocinare.com" || '';
  var startDate = new Date(apiData.startTime);
  var Y = startDate.getFullYear();
  var M = String(startDate.getMonth() + 1).padStart(2, '0');
  var D = String(startDate.getDate()).padStart(2, '0');
  var h = String(startDate.getHours()).padStart(2, '0');
  var min = String(startDate.getMinutes()).padStart(2, '0');

  function secondsToHMS(totalSeconds) {
    var H = Math.floor(totalSeconds / 3600);
    var m = Math.floor(totalSeconds % 3600 / 60);
    var s = totalSeconds % 60;
    return String(H).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }

  function fullUrl(path) {
    if (!path) return '';
    return imgHost + path;
  }

  function mapAppliance(list) {
    if (!list || !Array.isArray(list)) return [];
    return list.map(function (item) {
      return {
        name: item.name || '',
        emoji: '',
        image: fullUrl(item.imageUrl)
      };
    });
  }

  var cb = apiData.coffeeBean || {};

  return {
    brewInfo: {
      title: apiData.brewTitle || '',
      barista: apiData.nickname || '',
      brewTime: M + '-' + D + ' ' + h + ':' + min,
      brewDate: Y + '年' + M + '月' + D + '日 ' + h + ':' + min,
      duration: secondsToHMS(apiData.timerSeconds || 0)
    },
    brewParams: {
      bean: String(apiData.powderWeight || ''),
      water: String(apiData.waterWeight || ''),
      scale: '1:' + (apiData.waterPowderRatio || ''),
      finalScale: '1:' + (apiData.finalWaterPowderRatio || ''),
      flask: String(apiData.liquidWeight || ''),
      ratio: '1:' + (apiData.finalPowderLiquidRatio || '')
    },
    equipments: mapAppliance(apiData.applianceList && apiData.applianceList.qj),
    tastings: mapAppliance(apiData.applianceList && apiData.applianceList.pj),
    coffeeBean: {
      name: cb.name || '',
      origin: cb.origin || '',
      estate: cb.estate || '',
      roastLevel: cb.roastLevel || '',
      brand: cb.brand || '',
      imageUrl: fullUrl(cb.imageUrl)
    },
    chartData: {
      weightArray: apiData.weightSpots || [],
      flowRateArray: apiData.flowRates || [],
      avgFlowRateArray: apiData.avgFlowRates || [],
      flowRateTimes: apiData.flowRateTimes || []
    }
  };
}

/* harmony default export */ var share = ({
  name: 'ShareIndex',
  data: function data() {
    return {
      loading: true,
      dataEmpty: false,
      USE_MOCK: false,
      brewInfo: {
        title: '',
        barista: '',
        brewTime: '',
        brewDate: '',
        duration: ''
      },
      brewParams: {
        bean: '',
        water: '',
        scale: '',
        finalScale: '',
        flask: '',
        ratio: ''
      },
      equipments: [],
      tastings: [],
      coffeeBean: {
        name: '',
        origin: '',
        estate: '',
        roastLevel: ''
      },
      chartData: null,
      chartInstance: null,
      activeEquipmentIndex: 0,
      activeTastingIndex: 0
    };
  },
  mounted: function mounted() {
    this.fetchAllData();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },

  methods: {
    fetchAllData: function fetchAllData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var identity, data, response, _data$chartData, weightArray, flowRateArray, avgFlowRateArray, flowRateTimes, hasTimes, dataCount, flowMax, weightMax, xAxis, markPoints;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                identity = _this.$route.params.identity;
                data = void 0;
                _context.prev = 3;
                _context.next = 6;
                return getShare(identity);

              case 6:
                response = _context.sent;

                if (!(!response || !response.data)) {
                  _context.next = 10;
                  break;
                }

                _this.dataEmpty = true;
                return _context.abrupt('return');

              case 10:
                data = convertApiData(response.data);
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                if (!_this.USE_MOCK) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return fetchShareMock();

              case 18:
                data = _context.sent;
                _context.next = 23;
                break;

              case 21:
                _this.dataEmpty = true;
                return _context.abrupt('return');

              case 23:

                _this.brewInfo = data.brewInfo;
                _this.brewParams = data.brewParams;
                _this.equipments = data.equipments;
                _this.tastings = data.tastings;
                _this.coffeeBean = data.coffeeBean;

                _data$chartData = data.chartData, weightArray = _data$chartData.weightArray, flowRateArray = _data$chartData.flowRateArray, avgFlowRateArray = _data$chartData.avgFlowRateArray, flowRateTimes = _data$chartData.flowRateTimes;
                hasTimes = flowRateTimes && flowRateTimes.length > 0;
                dataCount = weightArray.length;
                flowMax = Math.ceil(Math.max.apply(Math, toConsumableArray_default()(flowRateArray)) / 2) * 2;
                weightMax = Math.ceil(Math.max.apply(Math, toConsumableArray_default()(weightArray)) / 100) * 100;
                xAxis = hasTimes ? { type: 'category', data: flowRateTimes } : { type: 'value', min: 0, interval: 20, max: (dataCount - 1) * 20 };
                markPoints = _this.generateRandomMarkPoints(weightArray, flowRateArray, avgFlowRateArray, hasTimes, flowRateTimes);


                _this.chartData = extends_default()({}, data.chartData, {
                  weightData: hasTimes ? weightArray : convertTo2DArray(weightArray),
                  flowRateData: hasTimes ? flowRateArray : convertTo2DArray(flowRateArray),
                  avgFlowRateData: hasTimes ? avgFlowRateArray : convertTo2DArray(avgFlowRateArray),
                  xAxis: xAxis,
                  yAxis: [{ name: 'g/s', min: 0, interval: 2, max: flowMax }, { name: 'g', min: 0, interval: 50, max: weightMax }],
                  markPoints: markPoints,
                  dataCount: dataCount
                });
                _context.next = 41;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context['catch'](0);

                console.error('数据加载失败:', _context.t1);

              case 41:
                _context.prev = 41;

                _this.loading = false;
                _this.$nextTick(function () {
                  _this.initChart();
                });
                return _context.finish(41);

              case 45:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 38, 41, 45], [3, 13]]);
      }))();
    },
    initChart: function initChart() {
      var chartDom = this.$refs.chartRef;
      if (!chartDom || !this.chartData) return;

      this.chartInstance = echarts["b" /* init */](chartDom);
      var _chartData = this.chartData,
          weightData = _chartData.weightData,
          flowRateData = _chartData.flowRateData,
          avgFlowRateData = _chartData.avgFlowRateData,
          xAxis = _chartData.xAxis,
          yAxis = _chartData.yAxis,
          markPoints = _chartData.markPoints,
          dataCount = _chartData.dataCount;


      var option = {
        animation: true,
        animationDuration: 1500,
        grid: {
          left: 50,
          right: 50,
          top: 40,
          bottom: dataCount > 6 ? 60 : 30
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: { color: '#333', fontSize: 12 }
        },
        dataZoom: dataCount > 6 ? [{
          type: 'slider',
          start: 0,
          end: 100,
          height: 20,
          bottom: 8,
          borderColor: '#e8e8e8',
          fillerColor: 'rgba(54, 211, 232, 0.15)',
          handleStyle: { color: '#36D3E8' },
          textStyle: { color: '#999', fontSize: 10 }
        }] : undefined,
        legend: {
          data: ['重量', '流速', '平均流速'],
          top: 0,
          right: 0,
          itemWidth: 16,
          itemHeight: 3,
          textStyle: { color: '#999', fontSize: 12 },
          itemGap: 12
        },
        xAxis: extends_default()({
          type: xAxis.type
        }, xAxis.type === 'category' ? {
          data: xAxis.data,
          boundaryGap: false
        } : {
          min: xAxis.min,
          max: xAxis.max,
          interval: xAxis.interval
        }, {
          axisLabel: {
            color: '#999',
            fontSize: 11,
            formatter: xAxis.type === 'category' ? undefined : function (val) {
              var m = Math.floor(val / 60);
              var s = val % 60;
              return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
            }
          },
          axisLine: { lineStyle: { color: '#e8e8e8' } },
          axisTick: { show: false },
          splitLine: { show: false }
        }),
        yAxis: [{
          type: 'value',
          name: yAxis[0].name,
          nameTextStyle: { color: '#999', fontSize: 11, padding: [0, 30, 0, 0] },
          min: yAxis[0].min,
          max: yAxis[0].max,
          interval: yAxis[0].interval,
          axisLabel: { color: '#999', fontSize: 11 },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
        }, {
          type: 'value',
          name: yAxis[1].name,
          nameTextStyle: { color: '#999', fontSize: 11, padding: [0, 0, 0, 30] },
          min: yAxis[1].min,
          max: yAxis[1].max,
          interval: yAxis[1].interval,
          axisLabel: { color: '#999', fontSize: 11 },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false }
        }],
        series: [{
          name: '重量',
          type: 'line',
          yAxisIndex: 1,
          data: weightData,
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#36D3E8', width: 2 },
          areaStyle: {
            color: new echarts["a" /* graphic */].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(54, 211, 232, 0.3)' }, { offset: 1, color: 'rgba(54, 211, 232, 0.02)' }])
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#36D3E8' },
            label: {
              show: true,
              color: '#fff',
              fontSize: 11,
              backgroundColor: '#36D3E8',
              borderRadius: 4,
              padding: [4, 8],
              position: 'top'
            },
            data: markPoints.filter(function (p) {
              return p.name === 'weight-mark';
            })
          }
        }, {
          name: '流速',
          type: 'line',
          yAxisIndex: 0,
          data: flowRateData,
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#FF9B44', width: 2 },
          areaStyle: {
            color: new echarts["a" /* graphic */].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(255, 155, 68, 0.25)' }, { offset: 1, color: 'rgba(255, 155, 68, 0.02)' }])
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#FF9B44' },
            label: {
              show: true,
              color: '#fff',
              fontSize: 11,
              backgroundColor: '#FF9B44',
              borderRadius: 4,
              padding: [4, 8],
              position: 'top'
            },
            data: markPoints.filter(function (p) {
              return p.name === 'flow-mark';
            })
          }
        }, {
          name: '平均流速',
          type: 'line',
          yAxisIndex: 0,
          data: avgFlowRateData,
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#926BFF', width: 2 },
          areaStyle: {
            color: new echarts["a" /* graphic */].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(146, 107, 255, 0.2)' }, { offset: 1, color: 'rgba(146, 107, 255, 0.02)' }])
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#926BFF' },
            label: {
              show: true,
              color: '#fff',
              fontSize: 11,
              backgroundColor: '#926BFF',
              borderRadius: 4,
              padding: [4, 8],
              position: 'top'
            },
            data: markPoints.filter(function (p) {
              return p.name === 'avg-mark';
            })
          }
        }]
      };

      this.chartInstance.setOption(option);
    },
    handleResize: function handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    generateRandomMarkPoints: function generateRandomMarkPoints(weightArray, flowRateArray, avgFlowRateArray, hasTimes, flowRateTimes) {
      var result = [];

      var getX = function getX(index) {
        return hasTimes && flowRateTimes ? flowRateTimes[index] : index * 20;
      };

      var weightIndex = Math.floor(Math.random() * weightArray.length);
      result.push({
        name: 'weight-mark',
        coord: [getX(weightIndex), weightArray[weightIndex]],
        value: weightArray[weightIndex] + 'g'
      });

      var flowIndex = Math.floor(Math.random() * flowRateArray.length);
      result.push({
        name: 'flow-mark',
        coord: [getX(flowIndex), flowRateArray[flowIndex]],
        value: flowRateArray[flowIndex] + ' g/s'
      });

      var avgIndex = Math.floor(Math.random() * avgFlowRateArray.length);
      result.push({
        name: 'avg-mark',
        coord: [getX(avgIndex), avgFlowRateArray[avgIndex]],
        value: avgFlowRateArray[avgIndex] + ' g/s'
      });

      return result;
    },
    handleEquipmentScroll: function handleEquipmentScroll() {
      this.updateActiveIndex('equipmentScroll', 'activeEquipmentIndex');
    },
    handleTastingScroll: function handleTastingScroll() {
      this.updateActiveIndex('tastingScroll', 'activeTastingIndex');
    },
    updateActiveIndex: function updateActiveIndex(scrollRef, activeIndexKey) {
      var container = this.$refs[scrollRef];
      if (!container) return;
      var scrollLeft = container.scrollLeft;
      var containerWidth = container.clientWidth;
      var itemWidth = 100;
      var gap = 12;
      var padding = containerWidth / 2 - 56;
      var centerX = scrollLeft + containerWidth / 2;
      var index = Math.round((centerX - padding - itemWidth / 2) / (itemWidth + gap));
      var listKey = activeIndexKey === 'activeEquipmentIndex' ? 'equipments' : 'tastings';
      var maxIndex = this[listKey].length - 1;
      this[activeIndexKey] = Math.max(0, Math.min(index, maxIndex));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/share/index.vue





//




function share_fetchShareMock() {
  return new promise_default.a(function (resolve) {
    setTimeout(function () {
      resolve({
        brewInfo: {
          title: '圣诞梦之夜',
          barista: '蜡笔小新',
          brewTime: '01-03 22:00',
          brewDate: '2024年01月03日 22:00',
          duration: '00:00:30'
        },
        brewParams: {
          bean: '15.0',
          water: '230',
          scale: '1:15.13',
          finalScale: '1:14.8',
          flask: '240',
          ratio: '1:15.7'
        },
        equipments: [{ name: '手冲壶', emoji: '🫖', image: '' }, { name: '研磨器', emoji: '', image: 'https://via.placeholder.com/100x100/FF9B44/FFFFFF?text=研磨' }, { name: '滤杯', emoji: '🥤', image: '' }, { name: '电子秤', emoji: '', image: 'https://via.placeholder.com/100x100/36D3E8/FFFFFF?text=秤' }, { name: '温度计', emoji: '🌡️', image: '' }, { name: '计时器', emoji: '⏱️', image: '' }],
        tastings: [{ name: '分享壶', emoji: '🫗', image: '' }, { name: '品鉴杯', emoji: '☕', image: '' }, { name: '滤纸', emoji: '🧻', image: '' }, { name: '闻香杯', emoji: '🥃', image: '' }, { name: '杯测勺', emoji: '🥄', image: '' }, { name: '风味轮', emoji: '🎨', image: '' }],
        coffeeBean: {
          name: '埃塞俄比亚 耶加雪菲',
          origin: '埃塞俄比亚',
          estate: '耶加雪菲',
          roastLevel: '浅度烘焙'
        },
        chartData: {
          weightArray: [100, 280, 360, 400, 430, 470, 500],
          flowRateArray: [0, 7.5, 5.2, 3.8, 2.5, 1.8, 1.2],
          avgFlowRateArray: [0, 7.5, 6.35, 5.5, 4.8, 5.6, 3.67]
        }
      });
    }, 500);
  });
}

function share_convertTo2DArray(array) {
  return array.map(function (value, index) {
    return [index * 20, value];
  });
}

function share_convertApiData(apiData) {
  var imgHost = "https://api.app.cocinare.com" || '';
  var startDate = new Date(apiData.startTime);
  var Y = startDate.getFullYear();
  var M = String(startDate.getMonth() + 1).padStart(2, '0');
  var D = String(startDate.getDate()).padStart(2, '0');
  var h = String(startDate.getHours()).padStart(2, '0');
  var min = String(startDate.getMinutes()).padStart(2, '0');

  function secondsToHMS(totalSeconds) {
    var H = Math.floor(totalSeconds / 3600);
    var m = Math.floor(totalSeconds % 3600 / 60);
    var s = totalSeconds % 60;
    return String(H).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }

  function fullUrl(path) {
    if (!path) return '';
    return imgHost + path;
  }

  function mapAppliance(list) {
    if (!list || !Array.isArray(list)) return [];
    return list.map(function (item) {
      return {
        name: item.name || '',
        emoji: '',
        image: fullUrl(item.imageUrl)
      };
    });
  }

  var cb = apiData.coffeeBean || {};

  return {
    brewInfo: {
      title: apiData.brewTitle || '',
      barista: apiData.nickname || '',
      brewTime: M + '-' + D + ' ' + h + ':' + min,
      brewDate: Y + '年' + M + '月' + D + '日 ' + h + ':' + min,
      duration: secondsToHMS(apiData.timerSeconds || 0)
    },
    brewParams: {
      bean: String(apiData.powderWeight || ''),
      water: String(apiData.waterWeight || ''),
      scale: '1:' + (apiData.waterPowderRatio || ''),
      finalScale: '1:' + (apiData.finalWaterPowderRatio || ''),
      flask: String(apiData.liquidWeight || ''),
      ratio: '1:' + (apiData.finalPowderLiquidRatio || '')
    },
    equipments: mapAppliance(apiData.applianceList && apiData.applianceList.qj),
    tastings: mapAppliance(apiData.applianceList && apiData.applianceList.pj),
    coffeeBean: {
      name: cb.name || '',
      origin: cb.origin || '',
      estate: cb.estate || '',
      roastLevel: cb.roastLevel || '',
      brand: cb.brand || '',
      imageUrl: fullUrl(cb.imageUrl)
    },
    chartData: {
      weightArray: apiData.weightSpots || [],
      flowRateArray: apiData.flowRates || [],
      avgFlowRateArray: apiData.avgFlowRates || [],
      flowRateTimes: apiData.flowRateTimes || []
    }
  };
}

/* harmony default export */ var components_share = ({
  name: 'ShareIndex',
  data: function data() {
    return {
      loading: true,
      dataEmpty: false,
      USE_MOCK: false,
      brewInfo: {
        title: '',
        barista: '',
        brewTime: '',
        brewDate: '',
        duration: ''
      },
      brewParams: {
        bean: '',
        water: '',
        scale: '',
        finalScale: '',
        flask: '',
        ratio: ''
      },
      equipments: [],
      tastings: [],
      coffeeBean: {
        name: '',
        origin: '',
        estate: '',
        roastLevel: ''
      },
      chartData: null,
      chartInstance: null,
      activeEquipmentIndex: 0,
      activeTastingIndex: 0
    };
  },
  mounted: function mounted() {
    this.fetchAllData();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },

  methods: {
    fetchAllData: function fetchAllData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var identity, data, response, _data$chartData, weightArray, flowRateArray, avgFlowRateArray, flowRateTimes, hasTimes, dataCount, flowMax, weightMax, xAxis, markPoints;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                identity = _this.$route.params.identity;
                data = void 0;
                _context.prev = 3;
                _context.next = 6;
                return getShare(identity);

              case 6:
                response = _context.sent;

                if (!(!response || !response.data)) {
                  _context.next = 10;
                  break;
                }

                _this.dataEmpty = true;
                return _context.abrupt('return');

              case 10:
                data = share_convertApiData(response.data);
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                if (!_this.USE_MOCK) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return share_fetchShareMock();

              case 18:
                data = _context.sent;
                _context.next = 23;
                break;

              case 21:
                _this.dataEmpty = true;
                return _context.abrupt('return');

              case 23:

                _this.brewInfo = data.brewInfo;
                _this.brewParams = data.brewParams;
                _this.equipments = data.equipments;
                _this.tastings = data.tastings;
                _this.coffeeBean = data.coffeeBean;

                _data$chartData = data.chartData, weightArray = _data$chartData.weightArray, flowRateArray = _data$chartData.flowRateArray, avgFlowRateArray = _data$chartData.avgFlowRateArray, flowRateTimes = _data$chartData.flowRateTimes;
                hasTimes = flowRateTimes && flowRateTimes.length > 0;
                dataCount = weightArray.length;
                flowMax = Math.ceil(Math.max.apply(Math, toConsumableArray_default()(flowRateArray)) / 2) * 2;
                weightMax = Math.ceil(Math.max.apply(Math, toConsumableArray_default()(weightArray)) / 100) * 100;
                xAxis = hasTimes ? { type: 'category', data: flowRateTimes } : { type: 'value', min: 0, interval: 20, max: (dataCount - 1) * 20 };
                markPoints = _this.generateRandomMarkPoints(weightArray, flowRateArray, avgFlowRateArray, hasTimes, flowRateTimes);


                _this.chartData = extends_default()({}, data.chartData, {
                  weightData: hasTimes ? weightArray : share_convertTo2DArray(weightArray),
                  flowRateData: hasTimes ? flowRateArray : share_convertTo2DArray(flowRateArray),
                  avgFlowRateData: hasTimes ? avgFlowRateArray : share_convertTo2DArray(avgFlowRateArray),
                  xAxis: xAxis,
                  yAxis: [{ name: 'g/s', min: 0, interval: 2, max: flowMax }, { name: 'g', min: 0, interval: 50, max: weightMax }],
                  markPoints: markPoints,
                  dataCount: dataCount
                });
                _context.next = 41;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context['catch'](0);

                console.error('数据加载失败:', _context.t1);

              case 41:
                _context.prev = 41;

                _this.loading = false;
                _this.$nextTick(function () {
                  _this.initChart();
                });
                return _context.finish(41);

              case 45:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 38, 41, 45], [3, 13]]);
      }))();
    },
    initChart: function initChart() {
      var chartDom = this.$refs.chartRef;
      if (!chartDom || !this.chartData) return;

      this.chartInstance = echarts["b" /* init */](chartDom);
      var _chartData = this.chartData,
          weightData = _chartData.weightData,
          flowRateData = _chartData.flowRateData,
          avgFlowRateData = _chartData.avgFlowRateData,
          xAxis = _chartData.xAxis,
          yAxis = _chartData.yAxis,
          markPoints = _chartData.markPoints,
          dataCount = _chartData.dataCount;


      var option = {
        animation: true,
        animationDuration: 1500,
        grid: {
          left: 50,
          right: 50,
          top: 40,
          bottom: dataCount > 6 ? 60 : 30
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: { color: '#333', fontSize: 12 }
        },
        dataZoom: dataCount > 6 ? [{
          type: 'slider',
          start: 0,
          end: 100,
          height: 20,
          bottom: 8,
          borderColor: '#e8e8e8',
          fillerColor: 'rgba(54, 211, 232, 0.15)',
          handleStyle: { color: '#36D3E8' },
          textStyle: { color: '#999', fontSize: 10 }
        }] : undefined,
        legend: {
          data: ['重量', '流速', '平均流速'],
          top: 0,
          right: 0,
          itemWidth: 16,
          itemHeight: 3,
          textStyle: { color: '#999', fontSize: 12 },
          itemGap: 12
        },
        xAxis: extends_default()({
          type: xAxis.type
        }, xAxis.type === 'category' ? {
          data: xAxis.data,
          boundaryGap: false
        } : {
          min: xAxis.min,
          max: xAxis.max,
          interval: xAxis.interval
        }, {
          axisLabel: {
            color: '#999',
            fontSize: 11,
            formatter: xAxis.type === 'category' ? undefined : function (val) {
              var m = Math.floor(val / 60);
              var s = val % 60;
              return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
            }
          },
          axisLine: { lineStyle: { color: '#e8e8e8' } },
          axisTick: { show: false },
          splitLine: { show: false }
        }),
        yAxis: [{
          type: 'value',
          name: yAxis[0].name,
          nameTextStyle: { color: '#999', fontSize: 11, padding: [0, 30, 0, 0] },
          min: yAxis[0].min,
          max: yAxis[0].max,
          interval: yAxis[0].interval,
          axisLabel: { color: '#999', fontSize: 11 },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
        }, {
          type: 'value',
          name: yAxis[1].name,
          nameTextStyle: { color: '#999', fontSize: 11, padding: [0, 0, 0, 30] },
          min: yAxis[1].min,
          max: yAxis[1].max,
          interval: yAxis[1].interval,
          axisLabel: { color: '#999', fontSize: 11 },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false }
        }],
        series: [{
          name: '重量',
          type: 'line',
          yAxisIndex: 1,
          data: weightData,
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#36D3E8', width: 2 },
          areaStyle: {
            color: new echarts["a" /* graphic */].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(54, 211, 232, 0.3)' }, { offset: 1, color: 'rgba(54, 211, 232, 0.02)' }])
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#36D3E8' },
            label: {
              show: true,
              color: '#fff',
              fontSize: 11,
              backgroundColor: '#36D3E8',
              borderRadius: 4,
              padding: [4, 8],
              position: 'top'
            },
            data: markPoints.filter(function (p) {
              return p.name === 'weight-mark';
            })
          }
        }, {
          name: '流速',
          type: 'line',
          yAxisIndex: 0,
          data: flowRateData,
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#FF9B44', width: 2 },
          areaStyle: {
            color: new echarts["a" /* graphic */].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(255, 155, 68, 0.25)' }, { offset: 1, color: 'rgba(255, 155, 68, 0.02)' }])
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#FF9B44' },
            label: {
              show: true,
              color: '#fff',
              fontSize: 11,
              backgroundColor: '#FF9B44',
              borderRadius: 4,
              padding: [4, 8],
              position: 'top'
            },
            data: markPoints.filter(function (p) {
              return p.name === 'flow-mark';
            })
          }
        }, {
          name: '平均流速',
          type: 'line',
          yAxisIndex: 0,
          data: avgFlowRateData,
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#926BFF', width: 2 },
          areaStyle: {
            color: new echarts["a" /* graphic */].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(146, 107, 255, 0.2)' }, { offset: 1, color: 'rgba(146, 107, 255, 0.02)' }])
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#926BFF' },
            label: {
              show: true,
              color: '#fff',
              fontSize: 11,
              backgroundColor: '#926BFF',
              borderRadius: 4,
              padding: [4, 8],
              position: 'top'
            },
            data: markPoints.filter(function (p) {
              return p.name === 'avg-mark';
            })
          }
        }]
      };

      this.chartInstance.setOption(option);
    },
    handleResize: function handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    generateRandomMarkPoints: function generateRandomMarkPoints(weightArray, flowRateArray, avgFlowRateArray, hasTimes, flowRateTimes) {
      var result = [];

      var getX = function getX(index) {
        return hasTimes && flowRateTimes ? flowRateTimes[index] : index * 20;
      };

      var weightIndex = Math.floor(Math.random() * weightArray.length);
      result.push({
        name: 'weight-mark',
        coord: [getX(weightIndex), weightArray[weightIndex]],
        value: weightArray[weightIndex] + 'g'
      });

      var flowIndex = Math.floor(Math.random() * flowRateArray.length);
      result.push({
        name: 'flow-mark',
        coord: [getX(flowIndex), flowRateArray[flowIndex]],
        value: flowRateArray[flowIndex] + ' g/s'
      });

      var avgIndex = Math.floor(Math.random() * avgFlowRateArray.length);
      result.push({
        name: 'avg-mark',
        coord: [getX(avgIndex), avgFlowRateArray[avgIndex]],
        value: avgFlowRateArray[avgIndex] + ' g/s'
      });

      return result;
    },
    handleEquipmentScroll: function handleEquipmentScroll() {
      this.updateActiveIndex('equipmentScroll', 'activeEquipmentIndex');
    },
    handleTastingScroll: function handleTastingScroll() {
      this.updateActiveIndex('tastingScroll', 'activeTastingIndex');
    },
    updateActiveIndex: function updateActiveIndex(scrollRef, activeIndexKey) {
      var container = this.$refs[scrollRef];
      if (!container) return;
      var scrollLeft = container.scrollLeft;
      var containerWidth = container.clientWidth;
      var itemWidth = 100;
      var gap = 12;
      var padding = containerWidth / 2 - 56;
      var centerX = scrollLeft + containerWidth / 2;
      var index = Math.round((centerX - padding - itemWidth / 2) / (itemWidth + gap));
      var listKey = activeIndexKey === 'activeEquipmentIndex' ? 'equipments' : 'tastings';
      var maxIndex = this[listKey].length - 1;
      this[activeIndexKey] = Math.max(0, Math.min(index, maxIndex));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df0ed6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/index.vue
var share_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[(_vm.loading)?_c('div',{staticClass:"loading-wrapper"},[_c('p',{staticClass:"loading-text"},[_vm._v("加载中...")])]):(_vm.dataEmpty)?_c('div',{staticClass:"empty-wrapper"},[_c('p',{staticClass:"empty-text"},[_vm._v("数据不存在")])]):[_c('div',{staticClass:"header-section"},[_c('h1',{staticClass:"brew-title"},[_vm._v(_vm._s(_vm.brewInfo.title))]),_vm._v(" "),_c('p',{staticClass:"brew-subtitle"},[_vm._v("咖啡师 | "+_vm._s(_vm.brewInfo.barista))])]),_vm._v(" "),_c('div',{staticClass:"card brew-info-card"},[_c('div',{staticClass:"brew-info-icon"},[_c('svg',{attrs:{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"8","y":"18","width":"26","height":"22","rx":"3","fill":"#333"}}),_vm._v(" "),_c('rect',{attrs:{"x":"10","y":"20","width":"22","height":"18","rx":"2","fill":"#5C3D2E"}}),_vm._v(" "),_c('path',{attrs:{"d":"M34 24C37 24 39 26 39 29C39 32 37 34 34 34","stroke":"#333","stroke-width":"3","fill":"none","stroke-linecap":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 16C16 12 18 12 18 8","stroke":"#999","stroke-width":"1.5","stroke-linecap":"round","fill":"none"}},[_c('animate',{attrs:{"attributeName":"d","values":"M16 16C16 12 18 12 18 8;M16 16C16 14 14 12 16 8;M16 16C16 12 18 12 18 8","dur":"2s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"opacity","values":"1;0.4;1","dur":"2s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M21 16C21 12 23 12 23 8","stroke":"#999","stroke-width":"1.5","stroke-linecap":"round","fill":"none"}},[_c('animate',{attrs:{"attributeName":"d","values":"M21 16C21 12 23 12 23 8;M21 16C21 14 19 12 21 8;M21 16C21 12 23 12 23 8","dur":"2.5s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"opacity","values":"0.8;0.3;0.8","dur":"2.5s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('path',{attrs:{"d":"M26 16C26 12 28 12 28 8","stroke":"#999","stroke-width":"1.5","stroke-linecap":"round","fill":"none"}},[_c('animate',{attrs:{"attributeName":"d","values":"M26 16C26 12 28 12 28 8;M26 16C26 14 24 12 26 8;M26 16C26 12 28 12 28 8","dur":"3s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"opacity","values":"0.6;0.2;0.6","dur":"3s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('ellipse',{attrs:{"cx":"21","cy":"28","rx":"3","ry":"2","fill":"#8B6914"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21","y1":"26","x2":"21","y2":"30","stroke":"#5C3D2E","stroke-width":"0.8"}})])]),_vm._v(" "),_c('div',{staticClass:"brew-info-text"},[_c('p',{staticClass:"brew-info-main"},[_vm._v(_vm._s(_vm.brewInfo.brewTime)+"冲泡")]),_vm._v(" "),_c('p',{staticClass:"brew-info-sub"},[_vm._v(_vm._s(_vm.brewInfo.brewDate))]),_vm._v(" "),_c('p',{staticClass:"brew-info-sub"},[_vm._v("历史："+_vm._s(_vm.brewInfo.duration))])])]),_vm._v(" "),_c('div',{staticClass:"card params-card"},[_c('div',{staticClass:"param-row"},[_c('div',{staticClass:"param-icon"},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}},[_c('ellipse',{attrs:{"cx":"11","cy":"11","rx":"8","ry":"6","fill":"#555"}}),_vm._v(" "),_c('ellipse',{attrs:{"cx":"11","cy":"11","rx":"8","ry":"6","stroke":"#555","stroke-width":"1"}}),_vm._v(" "),_c('line',{attrs:{"x1":"11","y1":"5","x2":"11","y2":"17","stroke":"#F8F9FA","stroke-width":"1.2"}})])]),_vm._v(" "),_c('span',{staticClass:"param-label"},[_vm._v("咖啡粉(g)")]),_vm._v(" "),_c('span',{staticClass:"param-value"},[_vm._v(_vm._s(_vm.brewParams.bean))])]),_vm._v(" "),_c('div',{staticClass:"param-row"},[_c('div',{staticClass:"param-icon"},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}},[_c('path',{attrs:{"d":"M11 3C11 3 4 12 4 15C4 18.5 7.1 21 11 21C14.9 21 18 18.5 18 15C18 12 11 3 11 3Z","fill":"#555"}})])]),_vm._v(" "),_c('span',{staticClass:"param-label"},[_vm._v("水(g)")]),_vm._v(" "),_c('span',{staticClass:"param-value"},[_vm._v(_vm._s(_vm.brewParams.water))])]),_vm._v(" "),_c('div',{staticClass:"param-row"},[_c('div',{staticClass:"param-icon"},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}},[_c('rect',{attrs:{"x":"10","y":"3","width":"2","height":"16","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6","y":"5","width":"10","height":"2","rx":"1","fill":"#555"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3 10L6 7H3V10Z","fill":"#555"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19 10L16 7H19V10Z","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2","y":"10","width":"5","height":"2","rx":"1","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"5","height":"2","rx":"1","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"7","y":"19","width":"8","height":"2","rx":"1","fill":"#555"}})])]),_vm._v(" "),_c('span',{staticClass:"param-label"},[_vm._v("粉水比")]),_vm._v(" "),_c('span',{staticClass:"param-value"},[_vm._v(_vm._s(_vm.brewParams.scale))])]),_vm._v(" "),_c('div',{staticClass:"param-row"},[_c('div',{staticClass:"param-icon"},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}},[_c('rect',{attrs:{"x":"10","y":"3","width":"2","height":"16","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6","y":"5","width":"10","height":"2","rx":"1","fill":"#555"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3 10L6 7H3V10Z","fill":"#555"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19 10L16 7H19V10Z","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2","y":"10","width":"5","height":"2","rx":"1","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"15","y":"10","width":"5","height":"2","rx":"1","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"7","y":"19","width":"8","height":"2","rx":"1","fill":"#555"}})])]),_vm._v(" "),_c('span',{staticClass:"param-label"},[_vm._v("实际粉水比")]),_vm._v(" "),_c('span',{staticClass:"param-value"},[_vm._v(_vm._s(_vm.brewParams.finalScale))])]),_vm._v(" "),_c('div',{staticClass:"param-row"},[_c('div',{staticClass:"param-icon"},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}},[_c('path',{attrs:{"d":"M7 3H15V9L18 17C18.5 18.5 17.5 20 16 20H6C4.5 20 3.5 18.5 4 17L7 9V3Z","fill":"#555"}}),_vm._v(" "),_c('rect',{attrs:{"x":"7","y":"2","width":"8","height":"2","rx":"1","fill":"#555"}})])]),_vm._v(" "),_c('span',{staticClass:"param-label"},[_vm._v("液重(g)")]),_vm._v(" "),_c('span',{staticClass:"param-value"},[_vm._v(_vm._s(_vm.brewParams.flask))])]),_vm._v(" "),_c('div',{staticClass:"param-row"},[_c('div',{staticClass:"param-icon"},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"4","stroke":"#555","stroke-width":"1.8","fill":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"14","cy":"14","r":"4","stroke":"#555","stroke-width":"1.8","fill":"none"}}),_vm._v(" "),_c('line',{attrs:{"x1":"15","y1":"5","x2":"7","y2":"17","stroke":"#555","stroke-width":"1.8"}})])]),_vm._v(" "),_c('span',{staticClass:"param-label"},[_vm._v("粉液比")]),_vm._v(" "),_c('span',{staticClass:"param-value"},[_vm._v(_vm._s(_vm.brewParams.ratio))])])]),_vm._v(" "),_c('div',{staticClass:"card chart-card"},[_c('h2',{staticClass:"section-title"},[_vm._v("冲煮曲线")]),_vm._v(" "),_c('div',{ref:"chartRef",staticClass:"chart-container"})]),_vm._v(" "),(_vm.equipments && _vm.equipments.length > 0)?_c('div',{staticClass:"card list-card"},[_c('h2',{staticClass:"section-title"},[_vm._v("咖啡器具")]),_vm._v(" "),_c('div',{staticClass:"scroll-wrapper"},[_c('div',{staticClass:"scroll-fade scroll-fade-left"}),_vm._v(" "),_c('div',{ref:"equipmentScroll",staticClass:"scroll-list",class:{ 'center-align': _vm.equipments.length < 3 },on:{"scroll":_vm.handleEquipmentScroll}},_vm._l((_vm.equipments),function(item,index){return _c('div',{key:index,staticClass:"scroll-item",class:{ active: _vm.activeEquipmentIndex === index }},[_c('div',{staticClass:"item-icon-box"},[(item.image)?_c('img',{staticClass:"item-image",attrs:{"src":item.image,"alt":item.name}}):_c('span',{staticClass:"item-emoji"},[_vm._v(_vm._s(item.emoji))])]),_vm._v(" "),_c('span',{staticClass:"item-name"},[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"scroll-fade scroll-fade-right"})]),_vm._v(" "),_c('div',{staticClass:"scroll-indicator"},_vm._l((_vm.equipments),function(item,index){return _c('span',{key:'dot-' + index,staticClass:"indicator-dot",class:{ active: _vm.activeEquipmentIndex === index }})}),0)]):_vm._e(),_vm._v(" "),(_vm.tastings && _vm.tastings.length)?_c('div',{staticClass:"card list-card"},[_c('h2',{staticClass:"section-title"},[_vm._v("品鉴")]),_vm._v(" "),_c('div',{staticClass:"scroll-wrapper"},[_c('div',{staticClass:"scroll-fade scroll-fade-left"}),_vm._v(" "),_c('div',{ref:"tastingScroll",staticClass:"scroll-list",class:{ 'center-align': _vm.tastings.length < 3 },on:{"scroll":_vm.handleTastingScroll}},_vm._l((_vm.tastings),function(item,index){return _c('div',{key:index,staticClass:"scroll-item",class:{ active: _vm.activeTastingIndex === index }},[_c('div',{staticClass:"item-icon-box"},[(item.image)?_c('img',{staticClass:"item-image",attrs:{"src":item.image,"alt":item.name}}):_c('span',{staticClass:"item-emoji"},[_vm._v(_vm._s(item.emoji))])]),_vm._v(" "),_c('span',{staticClass:"item-name"},[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"scroll-fade scroll-fade-right"})]),_vm._v(" "),_c('div',{staticClass:"scroll-indicator"},_vm._l((_vm.tastings),function(item,index){return _c('span',{key:'dot-' + index,staticClass:"indicator-dot",class:{ active: _vm.activeTastingIndex === index }})}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card bean-card"},[_c('h2',{staticClass:"section-title"},[_vm._v("咖啡豆")]),_vm._v(" "),_c('div',{staticClass:"bean-content"},[_c('div',{staticClass:"bean-image-box"},[(_vm.coffeeBean.image)?_c('img',{staticClass:"bean-image",attrs:{"src":_vm.coffeeBean.image,"alt":_vm.coffeeBean.name}}):_c('span',{staticClass:"bean-emoji"},[_vm._v(_vm._s(_vm.coffeeBean.emoji))])]),_vm._v(" "),_c('div',{staticClass:"bean-info"},[_c('p',{staticClass:"bean-name"},[_vm._v(_vm._s(_vm.coffeeBean.name))]),_vm._v(" "),_c('p',{staticClass:"bean-detail"},[_vm._v("产地: "+_vm._s(_vm.coffeeBean.origin))]),_vm._v(" "),_c('p',{staticClass:"bean-detail"},[_vm._v("庄园: "+_vm._s(_vm.coffeeBean.estate))]),_vm._v(" "),_c('p',{staticClass:"bean-detail"},[_vm._v("烘焙度: "+_vm._s(_vm.coffeeBean.roastLevel))])])])]),_vm._v(" "),_vm._m(0)]],2)}
var share_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('img',{staticClass:"footer-img",attrs:{"src":"/static/img/bottom.png"}})])}]
var share_esExports = { render: share_render, staticRenderFns: share_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_share = (share_esExports);
// CONCATENATED MODULE: ./src/components/share/index.vue
function share_injectStyle (ssrContext) {
  __webpack_require__("Y6jl")
}
var share_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var share___vue_template_functional__ = false
/* styles */
var share___vue_styles__ = share_injectStyle
/* scopeId */
var share___vue_scopeId__ = "data-v-9df0ed6e"
/* moduleIdentifier (server only) */
var share___vue_module_identifier__ = null
var share_Component = share_normalizeComponent(
  components_share,
  selectortype_template_index_0_src_components_share,
  share___vue_template_functional__,
  share___vue_styles__,
  share___vue_scopeId__,
  share___vue_module_identifier__
)

/* harmony default export */ var src_components_share = (share_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/community/index.vue
//
//
//
//
//

/// 社群-
/// 国内-zh
/// 海外-en
/// 日本-ja
/* harmony default export */ var community = ({
  name: 'index',
  data: function data() {
    return {
      type: null
    };
  },
  mounted: function mounted() {
    this.type = this.$route.params.type;
    this.toURL(this.type);
  },

  methods: {
    toURL: function toURL(type) {
      switch (type) {
        case 'zh':
          window.location.href = 'https://www.xiaohongshu.com/user/profile/63e36b9e0000000027028c7a';
          break;
        case 'en':
          window.location.href = 'https://www.instagram.com/cocinarecoffee/';
          break;
        case 'ja':
          window.location.href = 'https://www.instagram.com/epeios_jp';
          break;
        default:
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/community/index.vue
//
//
//
//
//

/// 社群-
/// 国内-zh
/// 海外-en
/// 日本-ja
/* harmony default export */ var components_community = ({
  name: 'index',
  data: function data() {
    return {
      type: null
    };
  },
  mounted: function mounted() {
    this.type = this.$route.params.type;
    this.toURL(this.type);
  },

  methods: {
    toURL: function toURL(type) {
      switch (type) {
        case 'zh':
          window.location.href = 'https://www.xiaohongshu.com/user/profile/63e36b9e0000000027028c7a';
          break;
        case 'en':
          window.location.href = 'https://www.instagram.com/cocinarecoffee/';
          break;
        case 'ja':
          window.location.href = 'https://www.instagram.com/epeios_jp';
          break;
        default:
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-634980ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/community/index.vue
var community_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var community_staticRenderFns = []
var community_esExports = { render: community_render, staticRenderFns: community_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_community = (community_esExports);
// CONCATENATED MODULE: ./src/components/community/index.vue
function community_injectStyle (ssrContext) {
  __webpack_require__("LTCV")
}
var community_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var community___vue_template_functional__ = false
/* styles */
var community___vue_styles__ = community_injectStyle
/* scopeId */
var community___vue_scopeId__ = "data-v-634980ac"
/* moduleIdentifier (server only) */
var community___vue_module_identifier__ = null
var community_Component = community_normalizeComponent(
  components_community,
  selectortype_template_index_0_src_components_community,
  community___vue_template_functional__,
  community___vue_styles__,
  community___vue_scopeId__,
  community___vue_module_identifier__
)

/* harmony default export */ var src_components_community = (community_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shop/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/// 商城渠道-
/// 国内-zh
/// 海外-en
/// 日本-ja
/* harmony default export */ var shop = ({
  name: 'index',
  data: function data() {
    return {
      type: null,
      isShow: false
    };
  },

  computed: {
    shopList: function shopList() {
      // 示例数据，可根据实际需求替换为接口数据
      return [{ id: 1, title: '小红书旗舰店', image: '/static/img/xiaohongshu.png', link: 'https://www.xiaohongshu.com/shop/640187b39a611c000123301a' }, { id: 2, title: '天猫旗舰店', image: '/static/img/tianmao.png', link: 'https://cocinare.world.tmall.com/shop/view_shop.htm?spm=a21xtw.29978516.0.0' }, { id: 3, title: '京东旗舰店', image: '/static/img/jingdong.png', link: 'https://mall.jd.com/index-19999727.html' }, { id: 4, title: '抖音旗舰店', image: '/static/img/douyin.png', link: 'https://v.douyin.com/81b97vko2FU/' }];
    }
  },
  mounted: function mounted() {
    this.type = this.$route.params.type;
    if (this.type === 'zh') {
      this.isShow = true;
    } else if (this.type === 'en') {
      window.location.href = 'https://www.cocinare.com/';
    } else if (this.type === 'ja') {
      window.location.href = 'https://epeios.jp/';
    }
  },

  methods: {
    goLink: function goLink(link) {
      window.location.href = link;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shop/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/// 商城渠道-
/// 国内-zh
/// 海外-en
/// 日本-ja
/* harmony default export */ var components_shop = ({
  name: 'index',
  data: function data() {
    return {
      type: null,
      isShow: false
    };
  },

  computed: {
    shopList: function shopList() {
      // 示例数据，可根据实际需求替换为接口数据
      return [{ id: 1, title: '小红书旗舰店', image: '/static/img/xiaohongshu.png', link: 'https://www.xiaohongshu.com/shop/640187b39a611c000123301a' }, { id: 2, title: '天猫旗舰店', image: '/static/img/tianmao.png', link: 'https://cocinare.world.tmall.com/shop/view_shop.htm?spm=a21xtw.29978516.0.0' }, { id: 3, title: '京东旗舰店', image: '/static/img/jingdong.png', link: 'https://mall.jd.com/index-19999727.html' }, { id: 4, title: '抖音旗舰店', image: '/static/img/douyin.png', link: 'https://v.douyin.com/81b97vko2FU/' }];
    }
  },
  mounted: function mounted() {
    this.type = this.$route.params.type;
    if (this.type === 'zh') {
      this.isShow = true;
    } else if (this.type === 'en') {
      window.location.href = 'https://www.cocinare.com/';
    } else if (this.type === 'ja') {
      window.location.href = 'https://epeios.jp/';
    }
  },

  methods: {
    goLink: function goLink(link) {
      window.location.href = link;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfcd1982","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/index.vue
var shop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"shop-page"},[_c('h2',{staticClass:"page-title"},[_vm._v("Cocinare各大官方旗舰店")]),_vm._v(" "),_c('div',{staticClass:"card-list"},_vm._l((_vm.shopList),function(item){return _c('div',{key:item.id,staticClass:"card",on:{"click":function($event){return _vm.goLink(item.link)}}},[_c('div',{staticClass:"card-title"},[_c('span',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',{staticClass:"arrow"},[_vm._v(">")])]),_vm._v(" "),_c('img',{staticClass:"card-img",attrs:{"src":item.image,"alt":item.title}})])}),0)]):_vm._e()}
var shop_staticRenderFns = []
var shop_esExports = { render: shop_render, staticRenderFns: shop_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_shop = (shop_esExports);
// CONCATENATED MODULE: ./src/components/shop/index.vue
function shop_injectStyle (ssrContext) {
  __webpack_require__("rWQE")
}
var shop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var shop___vue_template_functional__ = false
/* styles */
var shop___vue_styles__ = shop_injectStyle
/* scopeId */
var shop___vue_scopeId__ = "data-v-dfcd1982"
/* moduleIdentifier (server only) */
var shop___vue_module_identifier__ = null
var shop_Component = shop_normalizeComponent(
  components_shop,
  selectortype_template_index_0_src_components_shop,
  shop___vue_template_functional__,
  shop___vue_styles__,
  shop___vue_scopeId__,
  shop___vue_module_identifier__
)

/* harmony default export */ var src_components_shop = (shop_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





var routes = [{
  path: '/guide/:language/:identity',
  name: 'GuideIndex',
  component: src_components_guide
}, {
  path: '/share/:identity',
  name: 'ShareIndex',
  component: src_components_share
}, {
  path: '/community/:type',
  name: 'CommunityIndex',
  component: src_components_community
}, {
  path: '/shop/:type',
  name: 'ShopIndex',
  component: src_components_shop
}];

/* harmony default export */ var router = (routes);
// CONCATENATED MODULE: ./src/utils/globalConst.js
var title = '';
// 域名
var host = "https://api.app.cocinare.com/appApi/v1";
// 后台的授权URL
// const wxAuthUrl = host + '/wx/pageAuth'
// // 与后台对接校验的字符串
// const wxSignature = 'Ms7uTc9sY7lwR0mf1G'

/* harmony default export */ var globalConst = ({
  title: title, host: host
});
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.core.css
var quill_core = __webpack_require__("3f40");
var quill_core_default = /*#__PURE__*/__webpack_require__.n(quill_core);

// CONCATENATED MODULE: ./src/main.js















vue_esm["default"].use(element_ui_common_default.a);

vue_esm["default"].use(toast["a" /* default */]);
vue_esm["default"].prototype.MyGlobal = globalConst;
vue_esm["default"].use(vue_router_esm["a" /* default */]);

var main_router = new vue_router_esm["a" /* default */]({
  routes: router
});

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  router: main_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "RjyN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y6jl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rWQE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7d0f6fc49dd5219835b3.js